/* eslint-disable max-len */
/**
 * Enum of game type to view type
 * @link https://aspireglobal.atlassian.net/wiki/spaces/KAR/pages/176947255/Evolution+-+Live+Casino+Game+new+look+feel?focusedCommentId=366772225#Game-Types
 */
export const liveCasinoViewTypesEnum = {
    BLACKJACK: 'Blackjack',
    ROULETTE: 'Roulette',
    GAME_SHOW: 'GameShow',
    GENERAL: 'General',
};
